import { atom } from 'jotai';

import { notificationFeedQueryAtom } from '~/modules/notifications/_graphql/queryNotificationFeed';
import { NotificationFeedEntry } from '~/modules/notifications/types';

export const $notificationFeedCursor = atom<{ afterId: string } | undefined>(
  undefined,
);

export const $notificationFeed = notificationFeedQueryAtom((get) => ({
  variables: {
    cursor: get($notificationFeedCursor),
    limit: 20,
  },
}));

export const $notificationFeedEntries = atom<NotificationFeedEntry[]>([]);

$notificationFeedEntries.debugLabel = '$notifications.feedEntries';
